import React, { Component } from "react";
import MUIDataTable from "mui-datatables";
import { Button } from "@material-ui/core";
import moment from "moment";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { PostData } from "../../api/service";
import { confirmAlert } from "react-confirm-alert";
import { Badge, Tag } from "antd";

export default class GrievanceTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      isLoaded: false,
      openModal: false,
      openModalData: null,
      newStatus: 0,
      statusMessage: "",
      isSubmitting: false,
    };
  }

  handleDelete(rowsDeleted) {
    console.log(rowsDeleted);
  }

  onActionClick = (el) => {
    this.setState({
      openModal: true,
      openModalData: el,
      newStatus: parseInt(el.status),
      statusMessage: el.status_message,
    });
  };

  handleClose = () => {
    this.setState({
      openModal: false,
      openModalData: null,
    });
  };

  onClick() {
    console.log("hey");
  }

  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  onSubmit = () => {
    if (
      this.state.newStatus != "" &&
      this.state.statusMessage != "" &&
      this.state.openModalData != null
    ) {
      this.setState({
        isSubmitting: true,
      });
      // update the status
      PostData(`/updategrievancestatus`, {
        id: this.state.openModalData.id,
        status: this.state.newStatus,
        status_message: this.state.statusMessage,
      })
        .then((resp) => {
          this.setState({
            isSubmitting: false,
          });
          this.handleClose();
          if (resp.status) {
            confirmAlert({
              title: resp.message,
              buttons: [
                {
                  label: "OKAY",
                  onClick: () => this.props.reload(),
                },
              ],
            });
          } else {
            confirmAlert({
              title: resp.message,
              buttons: [
                {
                  label: "OKAY",
                },
              ],
            });
          }
        })
        .catch((err) => {
          this.setState({
            isSubmitting: false,
          });
        });
    }
  };

  render() {
    const columns = [
      {
        name: "Date Time",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "Type",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "Name",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "Phone",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "Email",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "Subject",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "Grievance Type",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "Message",
        options: {
          filter: true,
          sort: true,
          customBodyRender: (el) => {
            return <div dangerouslySetInnerHTML={{ __html: el }}></div>;
          },
        },
      },
      {
        name: "Status",
        options: {
          filter: true,
          sort: true,
          customBodyRender: (el) => {
            return <>
            {el == 1 && <Tag color="#196F3D">RESOLVED</Tag>}
            {el == 0 && <Tag color="#CB4335">PENDING</Tag>}
            </>;
          },
        },
      },
      {
        name: "Status Message",
        options: {
          filter: true,
          sort: true,
        },
      },

      {
        name: "Edit",
        options: {
          filter: false,
          sort: false,
          customBodyRender: (el) => {
            return (
              <Button
                size="small"
                variant="contained"
                color="primary"
                onClick={() => this.onActionClick(el)}
              >
                Update Status
              </Button>
            );
          },
        },
      },
    ];

    const options = {
      filterType: "checkbox",
      selectableRows: false,
      responsive: "scroll",
      rowsPerPage: 100,
    };

    let data = [];
    let table_data = this.props.table_data;
    if (table_data.length > 0) {
      data = table_data.map((el, index) => [
        el.time_stamp,
        el.type,
        el.name,
        el.phone,
        el.email,
        el.subject,
        el.grievance_type,
        el.message,
        el.status,
        el.status_message,
        el,
      ]);
    } else {
      data = [];
    }

    return (
      <div>
        <MUIDataTable
          title={"Topic"}
          data={data}
          columns={columns}
          options={options}
        />

        <Dialog
          open={this.state.openModal}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Update Grievance Status"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              You can update the status of the Grievance through this portal.
              The information will be sent to the email immediately after
              submission.
            </DialogContentText>

            <label>Select Status</label>
            <select
              className="form-control"
              name="newStatus"
              value={this.state.newStatus}
              onChange={this.onChange}
            >
              <option>Select</option>

              <option value={0}>PENDING</option>

              <option value={1}>RESOLVED</option>
            </select>

            <label>Message</label>
            <textarea
              className="form-control"
              name="statusMessage"
              value={this.state.statusMessage}
              placeholder="Write here"
              onChange={this.onChange}
            ></textarea>
          </DialogContent>
          <DialogActions>
            <Button color="primary" onClick={this.handleClose}>
              Cancel
            </Button>
            <Button
              color="primary"
              disabled={this.state.isSubmitting}
              autoFocus
              onClick={() => this.onSubmit()}
            >
              Submit
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
